/*
 * @Author: Czy
 * @Date: 2024-09-18 13:44:22
 * @FilePath: /museum-wechat/src/store/index.ts
 *
 */
import { createPinia } from 'pinia'
import { createPersistedState } from 'pinia-plugin-persistedstate' // 数据持久化

const store = createPinia()
store.use(
  createPersistedState({
    storage: {
      getItem: uni.getStorageSync,
      setItem: uni.setStorageSync,
    },
  }),
)

export default store

// 模块统一导出
export * from './user'
export * from './search'
export * from './sys'
export * from './hotel-fill-order'
export * from './order'
export * from './hotel-search-poi'
export * from './language'
